import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ExecutionEnvironment from 'exenv';
import { RefreshIndicator } from 'material-ui';

import ClientDetailsRenderer from './ClientDetailsRenderer';
import ClientListRenderer from './ClientListRenderer';
import styles from './styles.scss';
import ClientListFilters from './ClientListFilters';

@connect(state => ({
  viewport: state.Responsive.get('viewport'),
  windowHeight: state.Responsive.get('windowHeight'),
}))
export default class Clients extends React.Component {
  static propTypes = {
    viewport: PropTypes.string.isRequired,
    match: PropTypes.shape({
      params: PropTypes.object,
    }).isRequired,
    windowHeight: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      onClient: false,
    };
  }

  componentWillMount() {
    this.setState({ onClient: ExecutionEnvironment.canUseDom });
  }

  componentDidMount() {
    this.setState({ onClient: true }); // eslint-disable-line
  }

  render() {
    const { viewport, match: {
      params: { clientId: activeClient },
    }, windowHeight } = this.props;
    const { onClient } = this.state;
    const top = ((windowHeight - 161) / 2) + 161;

    const ActiveClient = <ClientDetailsRenderer activeClient={activeClient} />;

    if (viewport !== 'desktop' && activeClient) {
      return ActiveClient;
    }

    const loadingEl = (<div>
      <ClientListFilters updateFilter={() => null} />
      <RefreshIndicator top={top} left={277} status='loading' />
    </div>);

    return (<div className={styles.container}>
      <div className={styles.list}>
        {onClient ? <ClientListRenderer
          activeClient={activeClient}
          loadingEl={loadingEl}
        /> : loadingEl}
      </div>
      <div className={styles.detail}>{activeClient ? ActiveClient : null}</div>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Clients/Clients.js